import { render, staticRenderFns } from "./ConfirmOrderDetail.vue?vue&type=template&id=07feb1ed&scoped=true&"
import script from "./ConfirmOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07feb1ed",
  null
  
)

export default component.exports